export default __webpack_public_path__ + "static/media/web_logo_wo_margin.2622bf0f.png";